
export default class BankAccountFundResponseModel {
    public fundId: number = 0;
    public fundName: string = '';
    public balance: number = 0;
    public isDepositFund: boolean = false;
}
